import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <TopicsSection />
        <AppSection />
        <RankingSection />
        <IndexSection />
        <UpdatesSection />
        <CommentsSection />
        <ContactSection />
        <AboutSection />
        <CardsSection />
        <FeaturesSection />
        <FaqSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}